<template>
 <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-textarea  v-model="message"></v-textarea>
        </v-flex>
      </v-layout>
      <v-btn color="green" dark>
        <v-icon dark left>mdi-arrow-left-bold</v-icon>{{labels.exit}}
      </v-btn>
      <v-btn color="blue" dark>
        <v-icon dark left>mdi-content-save</v-icon>{{labels.save}}
      </v-btn>
      <v-btn color="yellow" dark>
        <v-icon dark left>mdi-arrow-expand-up</v-icon>{{labels.load}}
      </v-btn>
 </v-container>
</template>

<script>
export default {
  data () {
    return {
      labels: {
        exit: 'Exit',
        save: 'Save',
        load: 'Load Preset'
      }
    }
  }
}
</script>
